import React from 'react';
import PropTypes from 'prop-types';
import Facebook from 'react-sharingbuttons/dist/buttons/Facebook';
import Reddit from 'react-sharingbuttons/dist/buttons/Reddit';
import Email from 'react-sharingbuttons/dist/buttons/Email';

export default function Share({ title, url }) {
  return (
    <div className="d-flex justify-content-center blog-post-share-btn-container">
      <div className="d-inline-block">
        <Facebook url={url} />
      </div>

      <div className="d-inline-block">
        <a
          href={`https://x.com/intent/tweet/?text=${title}&url=${url}`}
          target="_blank"
          rel="noopener noreferrer nofollow"
          aria-label="X"
          style={{
            display: 'flex',
            backgroundColor: 'black',
            height: '44px',
            width: '44px',
            borderRadius: '50%',
            marginRight: '0.5rem',
            fontSize: '18px',
            justifyItems: 'center',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="https://cdn.fanatical.com/production/brand/social/twitter-x-white.svg"
            alt="X"
            style={{
              width: '18px',
              height: '18px',
            }}
          />
        </a>
      </div>

      <div className="d-inline-block">
        <Reddit url={url} text={title} />
      </div>

      <div className="d-inline-block">
        <Email url={url} text={title} subject={title} />
      </div>
    </div>
  );
}

Share.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
};

Share.defaultProps = {
  title: 'Fanatical',
  url: 'https://www.fanatical.com/en/',
};
